import { Descriptions, Card, Tag } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../../utils/axios";
import { useLoader } from "../../context/LoaderContext";
import { useTranslation } from "react-i18next";

const ProfileRapporteur = () => {
  const { t, i18n } = useTranslation();
  const { setIsLoading } = useLoader();
  const [userData, setUserData] = useState(null);
  const user = JSON.parse(localStorage.getItem("-x-token-user"));

  useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`${import.meta.env.VITE_APP_GEOPROD_API}/get_user_with_id`, {
        headers: {
          Idsession: user?.Acces_Token,
        },
      })
      .then((res) => {
        setUserData(res.data.user);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);

  if (!userData) return null;

  return (
    <Card 
    // title="Mon Profil"
    >
      <Descriptions column={2} bordered>
        <Descriptions.Item label={t("Gouvernorat")}>
          {userData.goverment}
        </Descriptions.Item>
        <Descriptions.Item label={t("Nom")}>{userData.nom}</Descriptions.Item>
        <Descriptions.Item label={t("Prénom")}>{userData.prenom}</Descriptions.Item>
        <Descriptions.Item label={t("Diplôme")}>
          {Array.isArray(userData.data_form.diplome) ? (
            userData.data_form.diplome.map((diplome, index) => (
              <Tag color="#6197CB" key={index}>
                {diplome}
              </Tag>
            ))
          ) : (
            <Tag color='#6197CB'>
              {userData.data_form.diplome}
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t("Expérience")}>
          {userData?.data_form?.experience}
        </Descriptions.Item>
        <Descriptions.Item label={t("Profil/compétences")} span={2}>
          {Array.isArray(userData.data_form.competences) ? (
            userData.data_form.competences.map((comp, index) => (
              <Tag color="#F69021" key={index}>
                {comp}
              </Tag>
            ))
          ) : (
            <Tag color="#F69021">
              {userData.data_form.competences}
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t("E-Mail")}>{userData.mail}</Descriptions.Item>
        <Descriptions.Item label={t("Téléphone")}>
          {userData.telephone}
        </Descriptions.Item>
        <Descriptions.Item label={t("CIN")}>{userData.cin}</Descriptions.Item>
        <Descriptions.Item label={t("Adresse")}>
          {userData.adresse}
        </Descriptions.Item>
        <Descriptions.Item label={t("Fonctionnaire d’État")}>
          {userData.fonctionnaire ? (
            <Tag color="green">{t("Oui")}</Tag>
          ) : (
            <Tag color="#FF808B">{t("Non")}</Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t("RIB")} span={2}>
          {userData.data_form.rib}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default ProfileRapporteur;
